import PropTypes from "prop-types";
import BatchDetailsCard from "./BatchDetailsCard";
import BatchProcessingTimeline from "./BatchProcessingTimeline";

export default function BatchSummaryDetails({ id, isSuperAdmin = false }) {
  return (
    <div className="flex flex-col md:flex-row gap-4">
      <div className="flex-1 flex flex-col">
        <BatchDetailsCard id={id} isSuperAdmin={isSuperAdmin} />
      </div>
      <div className="flex-1 flex flex-col">
        <BatchProcessingTimeline id={id} isSuperAdmin={isSuperAdmin} />
      </div>
    </div>
  );
}

BatchSummaryDetails.propTypes = {
  id: PropTypes.string,
  isSuperAdmin: PropTypes.bool,
};
